import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IBadgeApiResponse } from '../../../entity/interface/iRewardSystem';
import { IRewardRepository } from '../../repositories/interfaces/iRewardRepository';

export interface IGetBadgesUseCase {
    execute(identityToken: string, apiKey: string): Promise<IBadgeApiResponse['data']>;
}

export class GetBadgesUseCase implements IGetBadgesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get rewardRepository(): IRewardRepository {
        return container.resolve<IRewardRepository>(DI.REPOSITORIES.IRewardRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(identityToken: string, apiKey: string): Promise<IBadgeApiResponse['data']> {
        const response = await this.rewardRepository.getBadges(identityToken, apiKey);
        return response.data;
    }
}
